import * as React from 'react';

function SvgCircleCheck(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" ref={svgRef} {...props}>
      <path
        d="M11.305 4.582L6.2 9.87 4 7.742a.4.4 0 00-.563.01l-.735.76a.4.4 0 00.01.564l3.251 3.139a.4.4 0 00.563-.01l6.117-6.334a.4.4 0 00-.01-.564l-.761-.734a.4.4 0 00-.567.009zM7.988 16a7.988 7.988 0 117.988-7.988A7.988 7.988 0 017.988 16z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgCircleCheck);
export default ForwardRef;
